(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('operatingTimeFilter', operatingTime);

    /** @ngInject */
    function operatingTime($translate) {
        return function(text) {
			switch (text) {
				case 'true':
					return $translate.instant("OPENED_24");
				case 'false':
					return "";
				case '24hopen':
					return $translate.instant("OPENED_24");
				case '24hclose':
					return $translate.instant("CLOSED_24");
				case undefined:
					return " - ";
				default:
					return " - ";
			}
		};

    }

})();
